import DesignTokens from '@tableau/design-tokens';
import { ShareBaseIcon } from '@tableau/icons/ShareBaseIcon';
import {
  ButtonProps,
  ButtonType,
  InteractionState} from '@tableau/widgets';
import React from 'react';

import { applyColor } from '~src/style/ColorService';

import { Messages } from '../../../codegen/Localize';
import { ShareContentButtonStyles } from '../../styles/ShareContentButtonStyles';

export interface ShareContentButtonProps {
        readonly handleClick: () => void;
        readonly testId: string;
        readonly text?: string;
    }

const fillColorFor = (state: InteractionState): string => {
    if(state.disabled) {
        return applyColor(DesignTokens.color.font.default.disabled, '#bfbfbf');
    } else if(state.active || state.hover || state.selected) {
        return applyColor(DesignTokens.color.font.default.default, '#333');
    } else {
        return applyColor(DesignTokens.color.font.default.secondary, '#666');
    }
};

const ToolbarShareIcon = (interactiveState: InteractionState) => <ShareBaseIcon
    size={18}
    color={fillColorFor(interactiveState)}
    alt=''
    style={{ opacity: interactiveState.disabled ? 0.35 : 1 }}
/>;

export function ShareContentButton(props: ShareContentButtonProps): ButtonProps {
    return {
        buttonType: ButtonType.LowEmphasis,
        getContent: (state: InteractionState) => <div className={ShareContentButtonStyles.root}>
            {ToolbarShareIcon(state)}
            <div
                className={ShareContentButtonStyles.text}
                style={{color: fillColorFor(state)}}
            >
                {props.text}
            </div>
        </div>,
        title: Messages.shareContentButtonTitle(),
        handleClick: props.handleClick,
        testId: props.testId,
    };
}
